<!-- Error Views -->
<app-module-error *ngIf="isNoMetric" [noMetric]="true"></app-module-error>
<app-module-error *ngIf="isDateRangeTooWideIntraday" [dateRangeTooWideIntraday]="true"></app-module-error>
<app-module-error *ngIf="noData" [noData]="true"></app-module-error>
<!-- Content -->
<div id="legendTooltipSummary" class="legendTooltipSummary" [hidden]="false"></div>
<div class="h-100 w-100" *ngIf="dataLoadSuccess && !noData && !isDateRangeTooWideIntraday && !isNoMetric">

    <!-- Single Views -->
    <div class="d-flex position-relative h-100 w-100" *ngIf="moduleState.view !== 'dual'">
        <div *ngIf="moduleState.view === 'chart'" class="mx-2 chart-viewport">
            <div [ngClass]="{'chart-area-x': moduleState.graphState.chartType !== 'horizontalBar', 'chart-area-y': moduleState.graphState.chartType === 'horizontalBar'}">
                <div>
                    <canvas baseChart *ngIf="chartConfig"
                        [type]="chartConfig.type"
                        [legend]="chartConfig.options.plugins.legend"
                        [datasets]="chartConfig.data.datasets"
                        [labels]="chartConfig.data.labels"
                        [options]="chartConfig.options"
                        [plugins]="chartConfig.plugins">
                    </canvas>
                </div>
            </div>
        </div>
        
        <div class="performanceContent" *ngIf="moduleState.view === 'table'">
            <!-- Search -->
            <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
                <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChangeDebounced)="applyFilter()"
                    placeholder="Search" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
            </div>
            
            <!-- Search cxone -->
            <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!searchOpen">
                <sol-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
                (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400">
                </sol-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>
                                
            <!-- Ag Grid table component -->
            <div class="flex-fill intervalGridContainer h-100" style="overflow-y: auto;">
            <ag-grid-angular #summaryWidgetGrid *ngIf="gridOptions != null" [hidden]="gridOptions?.columnDefs?.length <= 0 || (isFirstLoad && !config.isCxOne)" 
                class="ag-theme-balham flex-fill"
                [gridOptions]="gridOptions"
                style="height:100%; width:100%;">
            </ag-grid-angular>
            </div>
        </div>

    </div>

    <!-- Combo View - Directives are repeated here but in visually-formatting divs. Using *ngIf, they won't render and won't affect performance. -->
    <div class="combinationView" *ngIf="moduleState.view === 'dual'">

        <!-- Ag Grid table component -->
        <div class="halfPanel d-flex flex-column position-relative" style="flex: 1 1 0px; min-width: 0px">
            <!-- Search -->
            <div *ngIf="!config.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!searchOpen">
                <input #searchBox type="search" class="form-control" autocomplete="off" [(ngModel)]="filterValue" [ngModelChangeDebounceTime]="400" (ngModelChangeDebounced)="applyFilter()"
                       placeholder="Search" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
            </div>

            <!-- Search cxone -->
            <div *ngIf="config.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!searchOpen">
                <sol-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search" name="cxoneInput-{{moduleKey}}"
                                  (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="400">
                </sol-text-input>
                <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-search-wrapper">
                        <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                    </svg>
                </i>
                <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
                    <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                        <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                    </svg>
                </i>
            </div>

            <!-- Error Container -->
            <div class="flex-fill intervalGridContainer" style="overflow-y: auto;">
                <ag-grid-angular #summaryWidgetGrid *ngIf="gridOptions != null"
                                 class="ag-theme-balham flex-fill"
                                 [gridOptions]="gridOptions"
                                 style="height:100%; width:100%;">
                </ag-grid-angular>
            </div>
        </div>

        <div class="panelDivider"></div>
        <!-- ChartJS -->
        <div class="halfPanel" style="margin-right: 7px">
            <div class="chart-viewport">
                <div [ngClass]="{'chart-area-x': moduleState.graphState.chartType !== 'horizontalBar', 'chart-area-y': moduleState.graphState.chartType === 'horizontalBar'}">
                    <div>
                        <canvas baseChart *ngIf="chartConfig"
                            [type]="chartConfig.type"
                            [legend]="chartConfig.options.plugins.legend"
                            [datasets]="chartConfig.data.datasets"
                            [labels]="chartConfig.data.labels"
                            [options]="chartConfig.options"
                            [plugins]="chartConfig.plugins">
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
